/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import QuotationSellKanbanKit from "components/EventComponents/EventDetailsComponents/EventQuotationsSell/QuotationSellKanbanKit/QuotationSellKanbanKitBody";

const QuotationSellKanban = () => {
  useEffect(() => {
    document.title = "Quotation Sell Kanban";
  }, []);

  return (
    <main id="app">
      <Header moduleName="events" />
      <QuotationSellKanbanKit />
    </main>
  );
};

export default QuotationSellKanban;
